export function extractDocumentName(buf: Uint8Array): string {
  let offset = 0;

  const readInt16 = (): number => {
    // Use little-endian byte order to match Java LITTLE_ENDIAN
    const value = buf[offset] | (buf[offset + 1] << 8);
    offset += 2;
    return value;
  };

  readInt16(); // skip buffer.getShort()
  offset += 1; // skip buffer.get()

  let size = buf[offset++] & 0xff;
  if (size === 0xff) {
    size = readInt16();
  }
  size = size * 2;

  const strBytes = new Uint8Array(size + 2);
  strBytes[0] = 0xff;
  strBytes[1] = 0xfe;
  strBytes.set(buf.slice(offset, offset + size), 2);
  offset += size;

  const decoder = new TextDecoder("utf-16le");
  const utf16Str = decoder.decode(strBytes);
  const utf8Bytes = new TextEncoder().encode(utf16Str);
  return new TextDecoder().decode(utf8Bytes).trim();
}
